import { useLocation } from "react-router-dom";
import Seo from "@/components/site/Seo";
import { Notice, PageHero } from "@/components/site/kit";
import { CONTACT } from "@/lib/site";

const DOCS = {
  "/privacy-policy": {
    title: "Privacy Policy",
    body: [
      ["Who we are", "This website is operated for the Telangana–Andhra T10 League by CGN Sports. For any privacy question, contact " + CONTACT.email + "."],
      ["Information we collect", "We collect the information you submit through our forms: player registrations (including date of birth, contact details, photograph and emergency contact), franchise, sponsorship, media and contact enquiries."],
      ["How we use it", "We use your information only to review registrations and enquiries, contact you about the league, and manage player eligibility, trials and selection. We do not sell your personal data."],
      ["Who can see it", "Submitted information is accessible only to authorised league administrators. Player personal information is never displayed publicly; only approved player profile information (such as name, playing role and style) may be published."],
      ["Storage and security", "Data is stored in secured databases and protected file storage with access controls. Uploaded files are validated before storage."],
      ["Your rights", "You may request access to, correction of, or deletion of your personal data by writing to " + CONTACT.email + "."],
    ],
  },
  "/terms": {
    title: "Terms and Conditions",
    body: [
      ["Use of this website", "By using this website you agree to these terms. Content is provided for information about the proposed Telangana–Andhra T10 League."],
      ["Registrations and enquiries", "Submitting a player registration or any enquiry does not create any contract, guarantee selection, franchise allocation, sponsorship or media rights."],
      ["Accuracy", "League details such as teams, venues, dates, sponsors and broadcasting are subject to official confirmation by CGN Sports and may change."],
      ["Intellectual property", "League names, marks and content on this website belong to their respective owners and may not be reused without permission."],
      ["Contact", "Questions about these terms can be sent to " + CONTACT.email + "."],
    ],
  },
  "/cookie-policy": {
    title: "Cookie Policy",
    body: [
      ["Essential cookies", "We use only the cookies needed to run the website securely, including authentication cookies for administrator sign-in."],
      ["Analytics", "No third-party advertising cookies are used. If analytics are added in future, this policy will be updated."],
      ["Managing cookies", "You can block or delete cookies through your browser settings; essential features such as admin sign-in may then stop working."],
    ],
  },
  "/disclaimer": {
    title: "Disclaimer",
    body: [
      ["Proposed league", "The Telangana–Andhra T10 League is a proposed league in development by CGN Sports."],
      ["Unconfirmed information", "Team names, player names, venue names, match dates, sponsors, franchise owners and broadcasting agreements are not confirmed unless explicitly announced on this website."],
      ["Broadcasting", "Broadcasting and OTT opportunities are under exploration. No broadcaster or OTT platform has been confirmed."],
      ["Demo content", "Content labelled \"Demo\" is sample content shown for layout purposes only and is not an official announcement."],
      ["No financial claims", "Nothing on this website is an offer of investment or a promise of returns. Franchise and commercial terms are subject to formal agreements."],
    ],
  },
};

export default function Legal() {
  const { pathname } = useLocation();
  const doc = DOCS[pathname] || DOCS["/privacy-policy"];
  return (
    <>
      <Seo title={doc.title} description={`${doc.title} of the Telangana–Andhra T10 League website.`} />
      <PageHero testid="legal-hero" eyebrow="Legal" title={doc.title} />
      <section data-testid="legal-content" className="container-x max-w-3xl py-16">
        <Notice>This page is a starting template and should be reviewed by CGN Sports' legal advisor before launch.</Notice>
        {doc.body.map(([h, p]) => (
          <div key={h} className="mt-10">
            <h2 className="font-display text-2xl uppercase">{h}</h2>
            <p className="mt-3 leading-relaxed text-slate-300">{p}</p>
          </div>
        ))}
      </section>
    </>
  );
}
